var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rotate-ccw"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.583374 2.33325V5.83325H4.08337",
    stroke: "#1D7777",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.04754 8.74993C2.42577 9.82348 3.14265 10.745 4.09017 11.3757C5.03769 12.0064 6.16452 12.3121 7.30087 12.2467C8.43723 12.1813 9.52154 11.7484 10.3904 11.0131C11.2594 10.2779 11.8658 9.28017 12.1183 8.17031C12.3709 7.06045 12.2559 5.89857 11.7907 4.85974C11.3255 3.8209 10.5353 2.96139 9.53919 2.41071C8.54304 1.86002 7.3949 1.648 6.26777 1.80658C5.14064 1.96516 4.09557 2.48576 3.29004 3.28993L0.583374 5.83326",
    stroke: "#1D7777",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateIc);
export default __webpack_public_path__ + "static/media/rotate-ic.3c7bb1bf3dfdce5e5e400ef97a20035c.svg";
export { ForwardRef as ReactComponent };